import { render, staticRenderFns } from "./SurveysDetails.vue?vue&type=template&id=470bd49b"
import script from "./SurveysDetails.js?vue&type=script&lang=js&external"
export * from "./SurveysDetails.js?vue&type=script&lang=js&external"
import style0 from "./SurveysDetails.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports